import React from 'react';
import { Landmark, Code, Cloud, ShieldCheck, Database, Sparkles, ArrowUpRight } from 'lucide-react';
import { services } from '../data/mock';

const iconMap = {
  Landmark,
  Code,
  Cloud,
  ShieldCheck,
  Database,
  Sparkles
};

const Services = () => {
  return (
    <section id="services" className="relative py-24 bg-white overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 pattern-grid" />

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-blue-50 border border-blue-100 mb-6">
            <span className="text-blue-700 text-xs font-semibold uppercase tracking-wider">Our Services</span>
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-slate-900 mb-4 font-display">
            Comprehensive <span className="gradient-text">Solutions</span>
          </h2>
          <p className="text-xl text-slate-600 max-w-2xl mx-auto">
            End-to-end technology services that transform how organizations operate and deliver value.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service) => {
            const IconComponent = iconMap[service.icon];
            return (
              <div
                key={service.id}
                className="group relative p-8 rounded-3xl bg-white border border-slate-200 hover:border-blue-200 transition-all duration-500 card-hover shadow-sm hover:shadow-xl hover:shadow-blue-500/10"
              >
                <div className="relative z-10">
                  {/* Icon */}
                  <div className={`w-14 h-14 rounded-2xl bg-gradient-to-br ${service.color} flex items-center justify-center mb-6 shadow-lg group-hover:scale-110 transition-transform duration-300`}>
                    <IconComponent className="w-7 h-7 text-white" />
                  </div>

                  {/* Content */}
                  <div className="text-xs text-slate-400 uppercase tracking-wider mb-2 font-medium">{service.subtitle}</div>
                  <h3 className="text-xl font-bold text-slate-900 mb-3 font-display group-hover:text-blue-600 transition-colors">
                    {service.title}
                  </h3>
                  <p className="text-slate-600 text-sm leading-relaxed line-clamp-3">
                    {service.description}
                  </p>

                  {/* Arrow */}
                  <div className="mt-6 flex items-center text-blue-600 text-sm font-medium opacity-0 group-hover:opacity-100 transition-opacity">
                    Learn More
                    <ArrowUpRight className="ml-1 w-4 h-4" />
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
